// extracted by mini-css-extract-plugin
export default {"modalBody":"BLA4MmStHhThklEXM7m9"};